import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-user-photos-modal',
  templateUrl: './user-photos-modal.component.html',
  styleUrls: ['./user-photos-modal.component.scss']
})
export class UserPhotosModalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
